import Doodles from '../Images/Portfolio-Thumbs/Doodles.jpg'
import Food from '../Images/Portfolio-Thumbs/Food.jpg'
import Photos from '../Images/Portfolio-Thumbs/Photos.jpg'
import Portfolio from '../Images/Portfolio-Thumbs/Portfolio.png'
import Hospitality from '../Images/Portfolio-Thumbs/Hospitality.png'
import Packaging from '../Images/Portfolio-Thumbs/Packaging.png'
import Talent from '../Images/Portfolio-Thumbs/Talent.png'
import Nomi from '../Images/Portfolio-Thumbs/Nomi.png'
import AIOps from '../Images/Portfolio-Thumbs/AIOps.png'

// Lazy loading modal components for better performance
import { lazy } from 'react'

const FoodModal = lazy(() => import('../../Components/PortfolioPage/FoodModal'))
const PhotoModal = lazy(() => import('../../Components/PortfolioPage/PhotoModal'))
const PortfolioModal = lazy(() => import('../../Components/PortfolioPage/PortfolioModal'))
const KDCModal = lazy(() => import('../../Components/PortfolioPage/KDCModal'))
const RDBModal = lazy(() => import('../../Components/PortfolioPage/RDBModal'))
const GraphicModal = lazy(() => import('../../Components/PortfolioPage/GraphicModal'))
const TeaModal = lazy(() => import('../../Components/PortfolioPage/TeaModal'))
const NomiModal = lazy(() => import('../../Components/PortfolioPage/NomiModal'))
const AIOpsModal = lazy(() => import('../../Components/PortfolioPage/AIOpsModal'))

let PortfolioData = [

    {
        id: 301,
        showItem: true,
        header: "Portfolio Build",
        type: "Technical PM",
        image: Portfolio,
        modal: <PortfolioModal />
    },

    {
        id: 309,
        showItem: true,
        header: "AI in Ops",
        type: "AI/ML",
        image: AIOps,
        modal: <AIOpsModal />
    },

    {
        id: 308,
        showItem: true,
        header: "nomi",
        type: "Entrepreneurship",
        image: Nomi,
        modal: <NomiModal />
    },

    {
        id: 302,
        showItem: true,
        header: "Green Packaging",
        type: "Design Thinking",
        image: Packaging,
        modal: <KDCModal />
    },

    {
        id: 303,
        showItem: true,
        header: "Hotel of the Future",
        type: "Ethnography",
        image: Hospitality,
        modal: <RDBModal />
    },

    {
        id: 304,
        showItem: true,
        header: "Capability Building",
        type: "Change Management",
        image: Talent,
        modal: <TeaModal />
    },

    {
        id: 305,
        showItem: false,
        header: "Gastronomy",
        type: "Innovation",
        image: Food,
        modal: <FoodModal />
    },

    {
        id: 306,
        showItem: true,
        header: "Photography",
        type: "Creativity",
        image: Photos,
        modal: <PhotoModal />
    },

    {
        id: 307,
        showItem: true,
        header: "Graphic Design",
        type: "Expression",
        image: Doodles,
        modal: <GraphicModal />
    },


];

export {PortfolioData};